import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getMyOnedriveOptions } from "@/api";
import { InlineNotice } from "@/components/InlineNotice";
import { DriveBrowser, type PickerSelection } from "./DriveBrowser";
import { RowsSkeleton } from "./DriveRows";

/** The person's own OneDrive, opened at its root ("My files"). */
export function OneDriveBrowser({ selection }: Readonly<{ selection: PickerSelection }>) {
  const { t } = useTranslation("chat", { keyPrefix: "cloud" });
  const oneDrive = useQuery(getMyOnedriveOptions());
  if (oneDrive.isError) return <InlineNotice tone="error">{t("loadFailed")}</InlineNotice>;
  if (!oneDrive.data) return <RowsSkeleton />;
  return (
    <DriveBrowser
      drive={oneDrive.data}
      rootCrumbs={[t("myFiles")]}
      searchLabel={t("searchOneDrive")}
      selection={selection}
    />
  );
}
